import { useEffect } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { getPaymentMethod } from 'api/services/payments';
import usePaymentsStore from '../store/paymentStore';
import useAccountStore from '../store/accountStore';
import usePermissions from './usePermissions';
import { auth, useAuthState } from '../api/services/firebase';

const useGetPaymentMethod = (shouldRefetch) => {
  const queryClient = useQueryClient();
  const { hasPermission } = usePermissions();
  const [user] = useAuthState(auth);
  const teamId = useAccountStore((state) => state.activeAccount.teamId);

  if (shouldRefetch) {
    queryClient.invalidateQueries({ queryKey: ['paymentMethod', teamId] });
  }

  const setPaymentMethod = usePaymentsStore((state) => state.setPaymentMethod);

  const {
    data, isLoading, error, refetch, isRefetching,
  } = useQuery({
    queryKey: ['paymentMethod', teamId],
    queryFn: getPaymentMethod,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    enabled: (
      !!user
      && (hasPermission('billing.user') || hasPermission('billing.team.edit'))
    ),
  });

  useEffect(() => {
    setPaymentMethod({
      card: data, isLoading, isRefetching, error,
    });
  }, [data, isLoading, isRefetching, error, setPaymentMethod]);

  return {
    refetch,
  };
};

export default useGetPaymentMethod;
